import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytes'
})
export class BytesPipe implements PipeTransform {

  private kilo = 1024;
  private mega = 1024 * 1024;
  private giga = 1024 * 1024 * 1024;

  transform(value: number): string {

    if (isNaN(value))
      return '-';

    if (value > this.giga) {
      return (value / this.giga).toFixed(2) + ' GB';
    }


    if (value > this.mega) {
      return (value / this.mega).toFixed(2) + ' MB';
    }


    if (value > this.kilo) {
      return (value / this.kilo).toFixed(2) + ' KB';
    }

    return value + ' B';

  }

  transformToNumber(value: number): number {

    if (isNaN(value))
      return 0;

    if (value > this.giga) {
      return +(value / this.giga).toFixed(2);
    }


    if (value > this.mega) {
      return +(value / this.mega).toFixed(2);
    }


    if (value > this.kilo) {
      return +(value / this.kilo).toFixed(2);
    }

    return value;

  }

}
